import { SearchUserEnriched } from 'lib-search-types';

import { getStatus, PresenceStatus } from './getStatus';
import { sortMembers } from './sortMembers';

export type StatusGroup = {
  status: PresenceStatus;
  members: SearchUserEnriched[];
};

const statusOrder: PresenceStatus[] = ['working', 'away', 'offline'];

/**
 * Groups members into working, away and offline, sorted by name within each
 * group and with the current user first in theirs. Empty groups are left out.
 */
export const groupMembersByStatus = (
  members: readonly SearchUserEnriched[],
  ownId: string,
): StatusGroup[] => {
  const groups: Record<PresenceStatus, SearchUserEnriched[]> = {
    working: [],
    away: [],
    offline: [],
  };

  for (const member of sortMembers(members)) {
    groups[getStatus(member)].push(member);
  }

  return statusOrder
    .map((status) => {
      const group = groups[status];
      const ownMember = group.find((member) => member.id === ownId);
      const others = group.filter((member) => member.id !== ownId);
      return {
        status,
        members: ownMember ? [ownMember, ...others] : others,
      };
    })
    .filter((group) => group.members.length > 0);
};
